import React, { Component } from 'react';
import '../../App.css';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Link } from 'react-router-dom';
import {uploadPaper, updatePaperInput} from '../../actions/paper.js';
import {getPricing, validateEmail} from '../../actions/pay.js';
import calculatePrice from '../../util/calculatePrice';
import '../../App.css';
import classname from 'classnames';

class LoadingScreen extends Component{
  constructor(props) {
    super(props);
  }

  render() {
    var loading_Styles = classname({
      'loading-wrapper': true,
      'no-loading'     : !(this.props.Paper.loading)
    });
    return (
      <div className={loading_Styles}>
        <div>
        <img className="loading-image" width={100} height={100} src="images/uploading.gif" />
          <br/><div>Uploading your paper </div>
        </div>
      </div>
    )
  }
}

export default connect(
  ({Paper, User})=>({Paper, User})
)(LoadingScreen);



// WEBPACK FOOTER //
// ./src/components/steps/LoadingScreen.js